var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"susseed"},[_c('img',{staticClass:"succeedImg",attrs:{"src":require("@/assets/image/activity/eitis/succeed.jpg"),"alt":""}})])}]

export { render, staticRenderFns }